module.exports = __webpack_public_path__ + "static/img/ubob-main.2397acb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ubob-main.jpg
// module id = 140
// module chunks = 0